import React from 'react'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, View } from 'react-native'
import { observer } from 'mobx-react-lite'

import { styles } from './styles'
import { BtLoading, BtText, BtButton } from '@linqpal/components/src/ui'

import projectStore from '../../../../Store'

type FooterProps = {
  onPress?: any
  onPressCancel?: any
  loading?: boolean
  isValidData?: boolean
}

export const Footer = observer(
  ({ onPress, onPressCancel, loading }: FooterProps) => {
    const { t } = useTranslation('global')

    const { selectedInvoices } = projectStore

    return (
      <View style={styles.footer}>
        <BtButton
          testID={'projects-detail-add-invoice-so-cancel-btn'}
          style={{ marginRight: 20, height: 56 }}
          appearance="outline"
          onPress={onPressCancel}
        >
          {t('Projects.cancel')}
        </BtButton>

        <TouchableOpacity
          testID={'projects-detail-add-invoice-so-btn'}
          onPress={onPress}
          activeOpacity={0.8}
          disabled={selectedInvoices.length === 0}
          style={
            selectedInvoices.length > 0 ? styles.button : styles.disabledBtn
          }
        >
          {loading ? (
            <BtLoading />
          ) : (
            <BtText
              style={
                selectedInvoices.length > 0
                  ? styles.labelActive
                  : styles.labelDisabled
              }
            >
              {t('InvoiceReceipt.add_to_project')}
            </BtText>
          )}
        </TouchableOpacity>
      </View>
    )
  },
)
